import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from '../ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'The Firm',
    href: '/about'
  }, {
    name: 'Practices',
    href: '/services'
  }, {
    name: 'Our Process',
    href: '/how-it-works'
  }, {
    name: 'For Employers',
    href: '/employers'
  }, {
    name: 'Insights',
    href: '/blog'
  }];
  return <>
      {/* Top utility bar */}
      <div className={`fixed top-0 w-full z-50 bg-navy-950 text-white text-xs transition-all duration-300 ${scrolled ? 'h-0 overflow-hidden opacity-0' : 'h-9 opacity-100'}`} data-id="element-112" data-mp="3bpsi09g884yg">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 h-full flex items-center justify-between" data-id="element-113" data-mp="32oc9k78z2cwv">
          <div className="hidden md:flex items-center gap-6 text-gray-300" data-id="element-114" data-mp="2xprgcrs50thx">
            <span className="tracking-widest uppercase text-[10px] text-gold-500" data-id="element-115" data-mp="2xrvip5ae1kg3">
              Global Executive Search & Leadership Advisory
            </span>
          </div>
          <div className="flex items-center gap-4 sm:gap-6" data-id="element-116" data-mp="2nyesscddgphp">
            <a href="tel:+16788073391" className="flex items-center gap-2 text-gray-300 hover:text-gold-500 transition-colors" data-id="element-117" data-mp="2jxbehuaz31il">
              <Phone className="h-3 w-3" data-id="element-118" data-mp="29zx4odjk1az9" />
              <span data-id="element-119" data-mp="29ylspqfygwx2">+1 (678) 807-3391</span>
            </a>
            <Link to="/recruitment-safety" className="hidden sm:inline text-gold-500 hover:text-white transition-colors" data-id="element-120" data-mp="2513tirrqpw29">
              Verify recruiter
            </Link>
            <span className="text-gray-500 hidden lg:inline" data-id="element-121" data-mp="20cudc6q9xnut">|</span>
            <span className="text-gray-400 hidden lg:inline" data-id="element-122" data-mp="209yf0haikx5u">
              42 Countries · 6 Regional Offices
            </span>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav className={`fixed w-full z-40 transition-all duration-300 ${scrolled ? 'top-0 bg-white shadow-md py-2' : 'top-9 bg-transparent py-4'}`} data-id="element-123" data-mp="1qg7u1mdlj4uw">
        <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-124" data-mp="2j1hg2ikza158">
          <div className="flex justify-between items-center" data-id="element-125" data-mp="25bnohsi392rt">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-5 mr-12" data-id="element-126" data-mp="29czjkdjqeg7e">
              {/* Circular Emblem */}
              <div className="relative flex-shrink-0" data-id="element-127" data-mp="2x2tugpkhpup0">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center transition-all duration-300 ${scrolled ? 'bg-navy-900 shadow-lg shadow-navy-900/30' : 'bg-white/15 backdrop-blur-md shadow-lg shadow-black/20'}`} data-id="element-128" data-mp="2x10j4wyxmmao">
                  <div className={`absolute w-14 h-14 rounded-full border transition-all duration-300 ${scrolled ? 'border-gold-500/60' : 'border-white/40'}`} data-id="element-129" data-mp="le6vjn6dgovf" />
                  <div className={`absolute w-11 h-11 rounded-full border transition-all duration-300 ${scrolled ? 'border-gold-500/30' : 'border-white/20'}`} data-id="element-130" data-mp="v62uf0ga8j0p" />
                  <div className="relative z-10 flex flex-col items-center justify-center" data-id="element-131" data-mp="2hfg5otyatwn">
                    <span className={`text-base font-serif font-bold leading-none tracking-tight transition-colors duration-300 ${scrolled ? 'text-gold-500' : 'text-white'}`} data-id="element-132" data-mp="hdwp69eo3wg1">
                      TB
                    </span>
                    <div className={`w-5 h-px mt-0.5 transition-colors duration-300 ${scrolled ? 'bg-gold-500/60' : 'bg-white/50'}`} data-id="element-133" data-mp="1ntp8j2n4z61t" />
                  </div>
                </div>
              </div>

              <div className="flex flex-col leading-none" data-id="element-134" data-mp="2cpwoalb3i1w">
                <span className={`text-xl font-serif font-bold tracking-wide transition-colors duration-300 ${scrolled ? 'text-navy-900' : 'text-white'}`} data-id="element-135" data-mp="6djhuw7d6ir3">
                  TalentBridge
                </span>
                <span className={`text-xs font-medium tracking-[0.2em] uppercase mt-0.5 transition-colors duration-300 ${scrolled ? 'text-gold-500' : 'text-white/70'}`} data-id="element-136" data-mp="gao7j60f4wcn">
                  Global
                </span>
              </div>
            </Link>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-10" data-id="element-137" data-mp="u4yoh166bm85">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium tracking-wide transition-colors hover:text-gold-500 ${scrolled ? 'text-gray-700' : 'text-white/90'}`} data-id="element-138" data-mp="yzukecej6tqj">
                  {link.name}
                </Link>)}
              <Button variant="gold" size="sm" href="mailto:contact@talentbridge.blog" data-id="element-139" data-mp="146j7yangempm">
                Book Consultation
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden" data-id="element-140" data-mp="1wxkn4br5ci95">
              <button onClick={() => setIsOpen(!isOpen)} className={`p-2 rounded-md ${scrolled ? 'text-navy-900' : 'text-white'}`} aria-label="Toggle menu" data-id="element-141" data-mp="1rvvdn0jkocn6">
                {isOpen ? <X className="h-6 w-6" data-id="element-142" data-mp="1j3tgpc8ppehn" /> : <Menu className="h-6 w-6" data-id="element-143" data-mp="2fmzne3z0d3ch" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="lg:hidden bg-white border-t absolute w-full shadow-lg" data-id="element-144" data-mp="8x5uk8xukm91">
            <div className="px-6 pt-2 pb-6 space-y-1" data-id="element-145" data-mp="dwiqdj6p53nr">
              {navLinks.map(link => <Link key={link.name} to={link.href} className="block px-3 py-3 text-base font-medium text-gray-700 hover:text-navy-900 hover:bg-gray-50 rounded-md border-b border-gray-100" data-id="element-146" data-mp="3vdjsbfig3lhh">
                  {link.name}
                </Link>)}
              <div className="pt-4" data-id="element-147" data-mp="3rcq3mjx6i2nj">
                <Button variant="gold" fullWidth href="mailto:contact@talentbridge.blog" data-id="element-148" data-mp="3r9ls11hdw4mu">
                  Book Consultation
                </Button>
              </div>
            </div>
          </div>}
      </nav>
    </>;
}